import script from "./SummarySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummarySection.vue?vue&type=script&setup=true&lang=ts"

import "./SummarySection.vue?vue&type=style&index=0&id=d40d220c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d40d220c"]])

export default __exports__